// src/apollo/client.ts
import { ApolloClient, HttpLink, InMemoryCache, from } from "@apollo/client"
import { setContext } from "@apollo/client/link/context"
import { onError } from "@apollo/client/link/error"
import { toast } from "react-toastify"
import config from "src/config/config"
import { emitMaintenanceEnabled } from "src/shared/maintenance/events"
import { logoutState } from "src/shared/store/slices/auth/auth"
import { store } from "src/shared/store/store"

// HTTP Link for GraphQL API
const httpLink = new HttpLink({
  uri: config.quark?.url
})

const getSubdomain = () => {
  const hostname = window.location.hostname
  // Handle localhost/127.0.0.1 case
  if (hostname === "localhost" || hostname === "127.0.0.1") return null

  // Split hostname by dots
  const parts = hostname.split(".")

  // Check if we have enough parts for a subdomain
  // For example: subdomain.domain.com has 3 parts
  if (parts.length >= 3) {
    return parts[0]
  }

  // Return null or empty string if no subdomain
  return null
}
// Auth Middleware (for JWT or session-based auth)
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token")

  const subDomain = getSubdomain()
  // Get account ID based on domain
  const storedAccountId = localStorage.getItem("account-id")

  const accountId = import.meta.env.VITE_TENANT ?? storedAccountId ?? subDomain
  return {
    headers: {
      ...headers,
      ["x-account-id"]: accountId,
      ["x-api-key"]: token
    }
  }
})

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  const context = operation.getContext()
  const ignoreError = context?.ignoreError
  if (ignoreError) return
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path, extensions }) => {
      console.error(`[GraphQL error]: config Message: ${message}, Location: ${locations}, Path: ${path}`, {
        message,
        locations,
        path
      })

      if (path?.includes("updateGrnReceivedStatus") || path?.includes("scanAuditLot")) return
      if (message?.toLowerCase().includes("maintenance") || extensions?.code === "MAINTENANCE") {
        emitMaintenanceEnabled(typeof message === "string" ? message : undefined)
        return
      }

      toast.error(message)

      if (path?.includes("authenticateToken")) {
        store.dispatch(logoutState())
        window.history.pushState({}, "", "/")
        window.location.reload()
      }
    })
  }
  if (networkError) {
    // toast.error("Unstable Network")
    console.error(`[Network error]: ${networkError}`, { networkError })
  }
})

// Apollo Client Instance
const apolloClient = new ApolloClient({
  link: from([authLink, errorLink, httpLink]),
  cache: new InMemoryCache()
})

export default apolloClient
